import axiosConfig from "./axiosConfig";

interface EventData {
  [key: string]: any;
}

const postEvent = async (eventData: EventData): Promise<void> => {
  const { data } = await axiosConfig.post(`/events`, eventData);
  return data;
};

export default postEvent;
